// extracted by mini-css-extract-plugin
export default {"spotlight-image-info-container":"b4XJf","criteo-spotLight-container":"L336G","info-icon":"k_Zok","info-container":"vmDH8"};